import { FC } from 'react';
import { enhanceComponent } from '@legacyApp/client/wrappers/enhanceComponent';
import { PackageType } from '@legacyApp/client/store/registry/registry.constants';

const SeedStoreController: FC = () => {
	return null;
};

export const seedStoreProps = {
	asyncReducers: [
		{
			id: 'seed',
			callback: () =>
				import('../../../LegacyApp/client/store.async/seed/seed.reducer'),
		},
	],
	asyncEpics: [
		{
			id: 'seed',
			callback: () =>
				import('../../../LegacyApp/client/store.async/seed/seed.epic'),
		},
	],
	asyncPackage: PackageType.SEED,
};

export default enhanceComponent({
	SeedStoreController,
	props: seedStoreProps,
});
